export default __webpack_public_path__ + "static/media/Sandwich.8ee5e1e1.svg";